import { BehaviorSubject, map, type Observable } from 'rxjs';
import type { TableDataSource, TablePage } from './table-data-source';

export class ObservableTableDataSource<T> implements TableDataSource<T> {
  readonly #data$: Observable<TablePage<T>>;

  constructor(data$: Observable<T[]>) {
    this.#data$ = data$.pipe(
      map(
        (data: T[]): TablePage<T> => ({
          pagination: {
            page: 1,
            size: data.length,
            totalCount: data.length,
          },
          data,
        }),
      ),
    );
  }

  getData$(): Observable<TablePage<T>> {
    return this.#data$;
  }

  get isLoading$(): Observable<boolean> {
    return new BehaviorSubject(false).asObservable();
  }
}
